import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { DefaultFilterComponent } from '../base-components/default-filter.component';
import { TextFieldOptions } from './textfield-options.interface';

@Component({
  standalone: false,
  selector: 'gstar-default-textfield-filter',
  templateUrl: './default-textfield-filter.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultTextfieldFilterComponent
  extends DefaultFilterComponent<string | string[]>
  implements OnInit
{
  pendingEntry = '';

  get isMultiEntryByEnter(): boolean {
    return !!this.filterColumn().getOptions<TextFieldOptions>()
      ?.multiEntryByEnter;
  }

  get selectedEntries(): string[] {
    const value = this.value();

    return Array.isArray(value) ? value : [];
  }

  constructor() {
    super();
    this.clearAll.subscribe(() => {
      this.pendingEntry = '';
      this.value.set(this.isMultiEntryByEnter ? [] : undefined);
    });
  }

  override ngOnInit(): void {
    super.ngOnInit();
    if (this.isMultiEntryByEnter && !Array.isArray(this.value())) {
      this.value.set([]);
    }
  }

  changeFieldHandler(value: string | string[]): void {
    this.update(value);
  }

  blurHandler(): void {
    if (this.isMultiEntryByEnter) {
      this.pendingEntry = this.pendingEntry.trim();
      return;
    }

    const rawValue = this.value();
    const value = typeof rawValue === 'string' ? rawValue.trim() : '';
    this.value.set(value);
    this.changeFieldHandler(value);
  }

  addEntryByEnter(event: Event): void {
    event.preventDefault();

    const entry = this.pendingEntry.trim();
    if (!entry) {
      return;
    }

    const entries = this.selectedEntries;
    if (entries.some(item => item.toLowerCase() === entry.toLowerCase())) {
      this.pendingEntry = '';
      return;
    }

    const updatedEntries = [...entries, entry];
    this.value.set(updatedEntries);
    this.changeFieldHandler(updatedEntries);
    this.pendingEntry = '';
  }

  removeEntry(index: number): void {
    const updatedEntries = this.selectedEntries.filter((_, i) => i !== index);
    this.value.set(updatedEntries);
    this.changeFieldHandler(updatedEntries);
  }
}
